import { useCallback } from "react";

import type { ReceiptSettingInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { RECEIPT_SETTING_UPDATE_MUTATION } from "./mutation";
import * as Query from "../../query";

export const useReceiptSettingMutation = () => {
	const { mutationFunc } = useCustomMutation(RECEIPT_SETTING_UPDATE_MUTATION);
	const onUpdateReceipt = useCallback(
		async (input: ReceiptSettingInput) => {
			return await mutationFunc({
				variables: { input },
				refetchQueries: [
					{
						query: Query.Schema.PAYMENT_CREDIT_QUERY,
						variables: {
							hotelID: input.hotelID,
						},
					},
				],
			});
		},
		[mutationFunc],
	);

	return {
		onUpdateReceipt,
	};
};
